<template>
  <!-- Since mobile responsive layout is fundamentally different, we render a different tree -->
  <div
    v-if="isMobileScreenSize"
    :class="[
      'flex flex-row items-center rounded-md gap-16 box-border w-full',
      isDoctorSelected(doctor.id)
        ? 'border-blue-500 border-2 p-23'
        : 'border p-24',
    ]"
  >
    <label for="selected">
      <input
        id="selected"
        :type="canSelectMultiple ? 'checkbox' : 'radio'"
        :checked="isDoctorSelected(doctor.id)"
        @change="
          (e) =>
            updateSelectedDoctors({
              doctor,
              isDelete: !e.target.checked,
              canSelectMultiple,
            })
        "
      />
    </label>
    <div class="flex flex-col gap-24">
      <NameSection :name="doctor.name" :gender="doctor.gender" />
      <ContactInfo
        :clinic="doctor.clinic"
        :address="doctor.address"
        :phone="doctor.phone"
      />
      <Body
        >({{
          $t('health_actions.scheduling.select_doctor_distance_miles', [
            doctor.distance,
          ])
        }})</Body
      >
    </div>
  </div>
  <!-- Desktop / Tablet view -->
  <div
    v-else
    :class="[
      'flex flex-row items-center rounded-md justify-between w-full',
      isDoctorSelected(doctor.id)
        ? 'border-blue-500 border-4 px-20 py-20'
        : 'border px-23 py-23',
    ]"
  >
    <div class="flex flex-row items-center gap-24">
      <label :for="`selected-${doctor.id}`">
        <input
          :id="`selected-${doctor.id}`"
          :checked="isDoctorSelected(doctor.id)"
          :type="canSelectMultiple ? 'checkbox' : 'radio'"
          @change="
            (e) => {
              $emit('user-did-select-doctor', doctor.id)
              updateSelectedDoctors({
                doctor,
                isDelete: !e.target.checked,
                canSelectMultiple,
              })
            }
          "
        />
      </label>
      <div class="flex flex-col gap-16">
        <NameSection :name="doctor.name" :gender="doctor.gender" />
        <ContactInfo
          :clinic="doctor.clinic"
          :address="doctor.address"
          :phone="doctor.phone"
        />
      </div>
    </div>
    <Body class="text-right self-start"
      >({{
        $t('health_actions.scheduling.select_doctor_distance_miles', [
          doctor.distance,
        ])
      }})</Body
    >
  </div>
</template>

<script>
import ContactInfo from './ContactInfoSection.vue'
import NameSection from './NameSection.vue'
import screenSizeMixin from '~/components/mixins/screenSizeMixin'
import { mapActions, mapGetters } from 'vuex'
import Body from '~/components/common/Typography/Body.vue'

export default {
  components: { Body, ContactInfo, NameSection },
  mixins: [screenSizeMixin],
  props: {
    doctor: {
      type: Object,
      required: true,
    },
    canSelectMultiple: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    ...mapGetters('scheduling', ['isDoctorSelected']),
  },
  methods: {
    ...mapActions('scheduling', ['updateSelectedDoctors']),
  },
}
</script>
